module.exports = __webpack_public_path__ + "img/icon-team-members.ce83b6d9.svg";